import type { FC } from 'react'

interface IDots {
  isDotted: boolean
}

const Dotts: FC<IDots> = ({ isDotted }) => {
  return <>{isDotted && <div className='dotts'>...</div>}</>
}

export default Dotts
